<script lang="ts">
  import Title from '$shared/atoms/Title/Title.svelte';
  import ConfirmActions from '$shared/atoms/ConfirmActions/ConfirmActions.svelte';
  import TextArea from '$shared/atoms/TextArea/TextArea.svelte';
  import ModalEvent from '$shared/constants/ModalEvent';
  import Label from '$shared/constants/Label';

  let title = 'Reject Match';
  let okLabel = Label.Reject;

  interface Props {
    loading?: boolean;
    onevent?: (payload: any) => void;
  }

  let { loading = false, onevent }: Props = $props();

  let notes = $state('');

  const handleOk = (): void => {
    onevent?.({ type: ModalEvent.ok, data: { notes } });
  };

  const handleCancel = (): void => {
    onevent?.({ type: ModalEvent.close });
  };

  const handleWindowKeyUp = (e: KeyboardEvent): void => {
    if (e.which == 13) {
      handleOk();
      return;
    }
  };

  const onChangeReason = (e: any): void => {
    notes = e.target.value.trim();
  };
</script>

<svelte:window onkeyup={handleWindowKeyUp} />
<div class="reject-popup">
  <div data-cy="reject-popup-title" class="title"><Title type="h3">{title}</Title></div>
  <div class="input-text">
    <TextArea
      name="reject-popup-note"
      placeholder="Add note (optional)"
      value={notes}
      oninput={onChangeReason}
    />
  </div>
  <div class="actions">
    <ConfirmActions {loading} {okLabel} onok={handleOk} oncancel={handleCancel} />
  </div>
</div>

<style>
  .reject-popup {
    padding: 24px;
    width: 400px;
  }
  .title {
    margin-bottom: 16px;
  }
  .actions {
    margin-top: 24px;
  }
</style>
